// @flow
import styled from "styled-components";
import { ThStat } from "../../../components/ThStat";

export const ThStatIgnored = styled(ThStat)`
	cursor: default;
	
	&:hover {
		background: rgba(0, 0, 0, 0);
	}
`;

export default ThStatIgnored;


// WEBPACK FOOTER //
// ./src/pages/league/preDraft/thStatIgnored.js